import { useAppContext } from "../../context";
import { ReactComponent as LightToggleIcon } from "../../assets/light.svg";
import { ReactComponent as DarkToggleIcon } from "../../assets/dark.svg";
import styles from "./styles";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Moon, Sun } from "lucide-react";

function ThemeToggle({ isNewDesign = false, onToggleTheme }) {
  const { isDarkMode, setIsDarkMode, setIsMenuOpen } = useAppContext();
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const docELement = document.querySelector("body");
    if (isDarkMode) {
      docELement.classList.add("dark");
      localStorage.setItem("uplus.rw-color-theme", "dark");
    } else {
      docELement.classList.remove("dark");
      localStorage.setItem("uplus.rw-color-theme", "light");
    }
  }, [isDarkMode]);

  const handleToggle = () => {
    setIsDarkMode((prev) => !prev);
    setIsMenuOpen(false);
    if (onToggleTheme) onToggleTheme();
  };

  if (isNewDesign) {
    return (
      <button
        className="p-2 rounded-full bg-white/10 hover:bg-white/20 overflow-hidden w-10 h-10 flex items-center justify-center"
        onClick={() => {
          handleToggle();
        }}
        aria-label="Toggle dark mode"
      >
        <div className="relative w-5 h-5 overflow-hidden -z-40">
          <div
            className={`absolute flex transition-transform duration-300 ease-in-out ${
              isDarkMode ? "-translate-x-5" : "translate-x-0"
            }`}
          >
            <div
              className={`transition-transform duration-300 ${
                isDarkMode ? "rotate-[-360deg]" : "rotate-0"
              }`}
            >
              <Sun className="h-5 w-5 text-white" />
            </div>
            <div
              className={`transition-transform duration-500 ${
                isDarkMode ? "rotate-[360deg]" : "rotate-0"
              }`}
            >
              <Moon className="h-5 w-5 text-white" />
            </div>
          </div>
        </div>
      </button>
    );
  }

  return (
    <div
      className={styles.toggleBtnContainer}
      onClick={() => {
        handleToggle();
      }}
    >
      <button className={styles.toggleBtn}>
        <LightToggleIcon
          className={`${styles.toggleIcon} ${
            !isDarkMode ? styles.onIconClick : ""
          }`}
        />
        <DarkToggleIcon
          className={`${styles.toggleIcon} ${
            isDarkMode ? styles.onIconClick : ""
          }`}
        />
        <span className={styles.scrReaderOnly}>Toggle dark mode</span>
      </button>
      <p
        className={`${styles.themeLabel} ${
          location.pathname.includes("/help-center")
            ? styles.darkMode
            : styles.lightMode
        }`}
      >
        {isDarkMode ? t("themes.lightMode") : t("themes.darkMode")}
      </p>
    </div>
  );
}

export default ThemeToggle;
